import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/footer/Footer';
import Menu from '../components/menu/Menu';
import { copyUrl } from '../../utils/url';

function AILanding() {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);

  return (
    <Container>
      <BottomNav onClick={() => window.open('/chat', '_blank')}>
        <BottomNavTextBox>
          <RowBox center gap={4}>
            <img src="/assets/images/ai-search/magnifier.svg" alt="" />
            <BottomNavText>
              <span>AI 경공매 찾기</span>
              체험하기
            </BottomNavText>
          </RowBox>
          <img
            src="/assets/images/ai-search/beta.svg"
            alt="beta"
            width={33}
            height={16}
          />
        </BottomNavTextBox>
      </BottomNav>

      <TopBar>
        <TopBarInner>
          <img
            src="/assets/images/promotion/free/Logo3.svg"
            alt=""
            style={{ width: '67px', height: '36px' }}
            onClick={() => navigate('/')}
          />
          <img
            src="/assets/images/promotion/free/Share.svg"
            width={24}
            height={24}
            alt=""
            style={{ marginRight: '-8px' }}
            onClick={() => copyUrl()}
          />
        </TopBarInner>
      </TopBar>

      <Content backgroundColor="#e7ebfa" gap={24} isTop>
        <Title>
          <BetaTag>
            <img
              src="/assets/images/ai-search/beta-badge.svg"
              alt="beta"
              width={41}
              height={20}
            />
          </BetaTag>
          <span>땅집고옥션 AI 경공매 찾기</span>
        </Title>
        <TitleDescription>
          당신만을 위한 경공매 투자, <br />
          이제 AI로 손쉽게 찾아보세요
        </TitleDescription>
        <MainImg src="/assets/images/ai-search/main.png" alt="" />
      </Content>

      <Content gap={32}>
        <SectionTitle>
          땅집고옥션 <br /> ‘AI 경공매 찾기'의 특별함
        </SectionTitle>
        <ColumnBox gap={24} center>
          <ColumnBox gap={16}>
            <RowBox gap={16}>
              <Number>01</Number>
              <ColumnBox gap={4}>
                <NumberTitle>AI 경공매 찾기</NumberTitle>
                <NumberDescription>
                  애매한 조건도 입력만 하면 알아서 척척 검색!
                </NumberDescription>
              </ColumnBox>
            </RowBox>
            <Divider />
            <RowBox gap={16}>
              <Number>02</Number>
              <ColumnBox gap={4}>
                <NumberTitle>따로 할 필요 없는 경매 분석</NumberTitle>
                <NumberDescription>
                  추천 물건은 클릭 한번으로 바로 상세 분석 가능
                </NumberDescription>
              </ColumnBox>
            </RowBox>
          </ColumnBox>
          <SubDescription>
            AI 경공매 탐색으로 실시간 경공매 물건을
            <br />
            대화로 쉽고 정확하게, 맞춤형으로 찾아드립니다.
          </SubDescription>
          <InteractionVideo
            src="/assets/images/ai-search/Interaction.mp4"
            autoPlay
            loop
            muted
            playsInline
            controls
          />
        </ColumnBox>
      </Content>
      <Content backgroundColor="#E1F1FF" gap={24}>
        <ColumnBox gap={8}>
          <SectionTitle isBlack>‘AI 경공매 찾기’ 런칭 기념</SectionTitle>
          <TitleDescription>땅집고옥션이 제대로 쏩니다!</TitleDescription>
        </ColumnBox>
        <ColumnBox gap={8} center>
          <Badge>혜택</Badge>
          <CountDescriptionBox>
            <RowBox gap={24} center style={{ padding: '8px' }}>
              <img
                src="/assets/images/ai-search/calendar.svg"
                alt=""
                width={80}
                height={80}
              />
              <ColumnBox gap={4}>
                <FreeUseDes>런칭기념 특별혜택</FreeUseDes>
                <FreeUseText>10월 말까지 모든 사용자</FreeUseText>
                <FreeUse>무료 이용!</FreeUse>
              </ColumnBox>
            </RowBox>

            <ColumnBox gap={8}>
              <GiveMessage>
                찾아주시는 모든 분들께
                <br />
                AI 탐색권 제공
              </GiveMessage>
              <ColumnBox gap={8}>
                <RowBox gap={8}>
                  <MembershipBox>
                    <MembershipBadge membership="비회원">
                      비회원
                    </MembershipBadge>
                    <MembershipDescription>
                      <MembershipDescriptionBig>7회</MembershipDescriptionBig>
                    </MembershipDescription>
                  </MembershipBox>
                  <MembershipBox>
                    <MembershipBadge membership="무료">
                      무료체험
                    </MembershipBadge>
                    <MembershipDescription>
                      <MembershipDescriptionBig>30회</MembershipDescriptionBig>
                    </MembershipDescription>
                  </MembershipBox>
                </RowBox>
                <RowBox gap={8}>
                  <MembershipBox>
                    <MembershipBadge membership="스탠다드">
                      스탠다드요금제
                    </MembershipBadge>
                    <MembershipDescription>
                      <MembershipDescriptionBig>
                        매월 300회
                      </MembershipDescriptionBig>
                    </MembershipDescription>
                  </MembershipBox>
                  <MembershipBox>
                    <MembershipBadge membership="프리미엄">
                      프리미엄요금제
                    </MembershipBadge>
                    <MembershipDescription>
                      <MembershipDescriptionBig>
                        매월 1000회
                      </MembershipDescriptionBig>
                    </MembershipDescription>
                  </MembershipBox>
                </RowBox>
              </ColumnBox>
            </ColumnBox>
          </CountDescriptionBox>
        </ColumnBox>
        <FinalText>
          AI 경공매 탐색, 지금 바로! <br />
          누구보다 빠르게, 남들과는 다르게 경험해보세요!
        </FinalText>
      </Content>
      <FooterContainer>
        <FooterInner>
          <FooterTitle>이벤트 유의사항</FooterTitle>
          <FooterDescriptionItem>
            <div>・</div>
            무료 이용 이벤트 기간 : ~10/31
          </FooterDescriptionItem>
          <FooterDescription>
            <span>탐색권 제공</span>
            <FooterDescriptionItem>
              <div>・</div>
              비회원 탐색권을 부정한 방식으로 반복 획득할 경우, 서비스 이용이
              제한될 수 있습니다.
            </FooterDescriptionItem>
            <FooterDescriptionItem>
              <div>・</div>
              무료회원 제공 탐색권은 가입 후 자동 지급되며, 스탠다드, 프리미엄
              제공 탐색권은 결제 후 요금제 사용 시작일에 탐색권이 지급됩니다.
            </FooterDescriptionItem>
          </FooterDescription>
        </FooterInner>
      </FooterContainer>
      <Footer />
    </Container>
  );
}

export default AILanding;

const Container = styled.div`
  user-select: none;
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
`;

const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #e7ebfa;
`;

const TopBarInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 16px;
  align-items: center;

  img {
    height: auto;
    cursor: pointer;
  }
`;

// const Container = styled.div`
//   user-select: none;
// `;

const Content = styled.div<{
  isTop?: boolean;
  backgroundColor?: string;
  gap?: number;
}>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding: ${({ isTop }) => (isTop ? '16px 16px 40px' : '40px 16px')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ gap }) => gap && `${gap}px`};
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  span {
    font-family: Paperlogy;
    font-weight: 700;
    font-size: 28px;
    line-height: 145%;
    background: linear-gradient(97.57deg, #0094ff -0.74%, #7c12ce 99.29%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
    text-align: center;
  }
`;

const TitleDescription = styled.div`
  font-family: Paperlogy;
  font-weight: 500;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
`;

const SectionTitle = styled.div<{ isBlack?: boolean }>`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 24px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ isBlack }) => (isBlack ? '#222' : '#008aff')};
  text-align: center;
`;

const ColumnBox = styled.div<{ gap?: number; center?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap && `${gap}px`};
  align-items: ${({ center }) => center && 'center'};
`;

const RowBox = styled.div<{ gap?: number; center?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: ${({ gap }) => gap && `${gap}px`};
  align-items: ${({ center }) => center && 'center'};
`;

const Number = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  padding: 16px;
  background: linear-gradient(97.57deg, #0094ff -0.74%, #7c12ce 99.29%);

  font-family: Paperlogy;
  font-weight: 600;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NumberTitle = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222;
`;

const NumberDescription = styled.div`
  font-family: Paperlogy;
  font-weight: 500;
  font-size: 16px;
  color: #616161;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e1e2e4;
`;

const SubDescription = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
`;

const InteractionVideo = styled.video`
  width: auto;
  height: 70vh;
  border-radius: 7vh;
  border: 4px solid #e1e2e4;
`;

const Badge = styled.div`
  border-radius: 999px;
  padding: 6px 12px;
  background-color: #222222;
  width: fit-content;

  font-family: Paperlogy;
  font-weight: 600;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #fd6d2f;
`;

const CountDescriptionBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 16px;
  padding: 16px;
  background-color: #fff;
`;

const FreeUseDes = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const FreeUseText = styled.div`
  font-family: Paperlogy;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
`;

const FreeUse = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 20px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #008aff;
`;

const MembershipBox = styled.div`
  border-radius: 12px;
  width: 100%;
  gap: 8px;
  padding: 12px;
  background: #f7f8fc;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const MembershipBadge = styled.div<{ membership: string }>`
  border-radius: 8px;
  padding: 6px 12px;
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: 0%;
  text-align: center;
  width: fit-content;

  ${({ membership }) => {
    switch (membership) {
      case '무료':
        return css`
          background: linear-gradient(94.45deg, #f0aa28 0%, #d22929 100%);
          color: #ffffff;
        `;
      case '스탠다드':
        return css`
          background: linear-gradient(94.45deg, #3cb5de 0%, #aad545 100%);
          color: #ffffff;
        `;
      case '프리미엄':
        return css`
          background: linear-gradient(94.45deg, #3f9bff 0%, #7c29fb 100%);
          color: #ffffff;
        `;
      default:
        return css`
          background: linear-gradient(94.45deg, #e0e1e6 0%, #bdc1c7 100%);

          color: #222222;
        `;
    }
  }}
`;

const MembershipDescription = styled.div`
  display: felx;
  flex-direction: column;
  gap: 4px;
  font-family: Paperlogy;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: 0%;
  text-align: center;

  span {
    font-weight: 700;
  }
`;

const MembershipDescriptionBig = styled.div`
  display: felx;
  flex-direction: column;
  gap: 4px;
  font-family: Paperlogy;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: 0%;
  text-align: center;

  font-weight: 700;
`;

const FinalText = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
`;

const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  background: #1f1f1f;
`;

const FooterTitle = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 24px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #ffffff;
`;

const FooterDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #b0b0b0;

  span {
    font-weight: 700;
    font-size: 16px;
  }
`;

const FooterInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FooterDescriptionItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  color: #b0b0b0;
`;

const BottomNav = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #451db8 0%, #541585 100%);
  padding: 8px 16px;
  box-shadow: 0px 4px 24px 0px #3d454e1a;

  position: fixed;
  z-index: 100;
  bottom: 0;
  cursor: pointer;

  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #fff;
`;

const BottomNavTextBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
`;

const BottomNavText = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #fff;
  padding: 6px 0;

  span {
    font-weight: 700;
  }
`;

const BetaTag = styled.div`
  border-radius: 999px;
  padding: 8px 16px;
  background-color: #222222;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MainImg = styled.img`
  width: auto;
  height: 50vh;
`;

const GiveMessage = styled.div`
  font-family: Paperlogy;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: 0%;
  text-align: center;
`;
